import React, { memo, useState } from 'react';
import { Collapse, IconButton, List, ListItemButton, ListItemText, ListSubheader, Popover } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import first from 'lodash/first';
import size from 'lodash/size';

const GroupWithSubList = ({ section, applyWord }) => {

  const [ isOpen, setIsOpen ] = useState(false);

  return (<>
    <ListItemButton
      onClick={() => setIsOpen(!isOpen)}>
      <ListItemText primary={section.text} />
      {isOpen ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {section.words.map((word, w_idx) => (
          <ListItemButton key={w_idx} sx={{ pl: 4 }}
                          onClick={() => applyWord(word)}>
            <ListItemText primary={word.sourceContent} />
          </ListItemButton>
        ))}
      </List>
    </Collapse>
  </>);
};

const HelpForInput = (props) => {

  const { setWordToMutate, sections, title } = props;

  const [ anchorElForExamples, setAnchorElExamples ] = useState(null);

  const openExamples = (event) => {
    setAnchorElExamples(event.currentTarget);
  };

  const closeExamples = () => {
    setAnchorElExamples(null);
  };

  const applyWord = (word) => {
    setWordToMutate(word.copy());

    closeExamples();
  };

  const nbOfSections = size(sections);

  return <>
    <IconButton
      aria-label="Examples"
      aria-haspopup="true"
      onClick={event => openExamples(event)}
      size="large">
      <HelpOutlineIcon />
    </IconButton>
    <Popover
      open={Boolean(anchorElForExamples)}
      anchorEl={anchorElForExamples}
      onClose={closeExamples}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <List
        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            {title}
          </ListSubheader>
        }
      >
        {nbOfSections > 1 && sections.map((section, idx) => (
          <GroupWithSubList key={idx} section={section}
                 applyWord={applyWord} />
        ))}
        {nbOfSections === 1 && (first(sections).words.map((word, w_idx) => (
          <ListItemButton key={w_idx} sx={{ pl: 4 }}
                          onClick={() => applyWord(word)}>
            <ListItemText primary={word.sourceContent} />
          </ListItemButton>
        )))}
      </List>
    </Popover>

  </>;
};

export default memo(HelpForInput);
